import { render, staticRenderFns } from "./WechatAuth.vue?vue&type=template&id=6cd9f449&scoped=true&"
import script from "./WechatAuth.vue?vue&type=script&lang=js&"
export * from "./WechatAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd9f449",
  null
  
)

export default component.exports